export class ScrollNav {
    constructor() {
        const target = document.querySelector("#menus-container");

        const checkScroll = () => {
            if (window.scrollY > 0) {
                if (!target.hasAttribute("data-scroll")) {
                    target.setAttribute("data-scroll", "");
                }
            } else {
                target.removeAttribute("data-scroll");
            }
        };

        window.addEventListener("scroll", checkScroll, { passive: true });
        checkScroll();
    }
}
